import {ErrorHandler, provideZonelessChangeDetection} from '@angular/core';
import {getAnalytics, provideAnalytics, ScreenTrackingService} from '@angular/fire/analytics';
import {initializeApp, provideFirebaseApp} from '@angular/fire/app';
import {getDatabase, provideDatabase} from '@angular/fire/database';
import {getFunctions, provideFunctions} from '@angular/fire/functions';
import {getMessaging, provideMessaging} from '@angular/fire/messaging';
import {bootstrapApplication} from '@angular/platform-browser';
import {provideAnimations} from '@angular/platform-browser/animations';
import {provideRouter, withInMemoryScrolling} from '@angular/router';
import {AppComponent} from './app/app.component';
import {CustomErrorHandler} from './app/common/error-handler';
import {routes} from './app/routes';
import {environment} from './environments/environment';


bootstrapApplication(AppComponent, {
    providers: [
        provideZonelessChangeDetection(),
        provideRouter(routes, withInMemoryScrolling({scrollPositionRestoration: 'enabled'})),
        provideAnimations(),
        provideFirebaseApp(() => initializeApp(environment.firebase)),
        provideAnalytics(() => getAnalytics()),
        provideDatabase(() => getDatabase()),
        provideFunctions(() => getFunctions()),
        provideMessaging(() => getMessaging()),
        ScreenTrackingService,
        { provide: ErrorHandler, useClass: CustomErrorHandler },
    ]
}).catch(err => console.error(err));
